import { RDI_WIZARD_CONFIG } from '../../../patient-files/actions/rdi/rdiWizardConfig';
import { ClinicalDocPanel } from './ClinicalDocPanel';

interface RefinementRdiPanelProps {
    patientId: string;
    /** ISO cutoff (case phaseEnteredAt) — only RDIs from the current refinement. */
    since?: string | null;
}

export function RefinementRdiPanel({ patientId, since = null }: RefinementRdiPanelProps) {
    return (
        <ClinicalDocPanel
            patientId={patientId}
            since={since}
            title="RDI"
            timelineType="rdi_submission"
            wizardConfig={RDI_WIZARD_CONFIG}
            openAction="rdi"
            emptyText="No RDI created yet for this refinement."
        />
    );
}
